export const state = () => ({
  urlFile: 'https://loja-mege.s3.us-west-2.amazonaws.com/',
})
